module.exports = __webpack_public_path__ + "img/spin_wheel_bg_rt.f7afaaeb.png";